import React from 'react';

function MenuBurgerIcon({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g fill={color} clipPath="url(#clip0_4231_30150)">
        <path d="M23 11H1a1 1 0 100 2h22a1 1 0 100-2zM23 4H1a1 1 0 000 2h22a1 1 0 100-2zM23 18H1a1 1 0 100 2h22a1 1 0 100-2z"></path>
      </g>
      <defs>
        <clipPath id="clip0_4231_30150">
          <path fill={color} d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default MenuBurgerIcon;
